import request from "../request";

export const getUserList = () => {
  const url = `/user/all`;
  return request.get(url);
};

export const getUserById = ({ id }) => {
  const url = `/user/${id}`;
  return request.get(url);
};

export const getUsersWithKeyword = (keyword) => {
  const url = `/user/list?keyword=${keyword}`;
  return request.get(url);
};

export const deleteUser = ({ id }) => {
  const url = `/user/${id}`;
  return request.delete(url);
};

export const getRoleList = () => {
  const url = `/role/all`;
  return request.get(url);
};

export const addUser = (payload) => {
  const url = "/user";
  return request.post(url, payload);
};

export const editUser = (payload) => {
  const url = "/user";
  return request.put(url, payload);
};

export const getUserWithRole = (role) => {
  const payload = {
    userRoles: [{ code: role }],
  };
  const url = `/user/list_by_roles`;
  return request.post(url, payload);
};

export const getUserWithRoleAndRegion = (role,region, role2) => {
  let payload = null
  if(role2){
    payload = {
      userRoles: [{ code: role },{ code: role2}],
      regionCode:region
    };
  }else{
    payload = {
      userRoles: [{ code: role }],
      regionCode:region
    };
  }
  
  const url = `/user/list_by_roles`;
  return request.post(url, payload);
};

export const getUserInfo = (username) => {
  const url = `/user/info/${username}`;
  return request.get(url);
};
